export const getTrackingReferrerFromUrl = () => {
  if (!document.referrer) return 'direct';
  const path = new URL(document.referrer).pathname;
  if (path.includes('/collections')) return 'collection';
  if (path.includes('/search')) return 'search';
  if (path.includes('/product')) return 'pdp';
  if (path.includes('/blogs/')) return 'stack';
  if (path.includes('/account')) return 'account';
  return 'homepage';
};
